import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import BookCover from 'rebook/apps/books/components/BookCover';
import BookRating from 'rebook/apps/books/components/BookRating';
import MultilineEllipsisText from 'rebook/apps/base/components/MultilineEllipsisText';
import { Author } from 'rebook/apps/catalog/models';
import { Book } from 'rebook/apps/books/models';

import styles from './style.scss';


const VerticalBookCard = ({ isActiveItem, order, ...otherProps }) => {
  const book = new Book(otherProps.book);
  const bookRating = book.rating;
  const mainAuthor = book.main_author ? new Author(book.main_author) : null;
  const isAudioBook = book.type === 'audio';
  const audioBookImageHeight = isAudioBook ? 124 : 196;
  return (
    <div className={classNames(
      styles.tinyBook,
      'swiper-slide',
      'jest-verticalbookcard',
    )}>
      <div className={styles.bookCover}>
        <BookCover
          book={book}
          isActiveItem={isActiveItem}
          showSubscription
          isAudioBook={isAudioBook}
          height={audioBookImageHeight}
          width={124} />
      </div>
      <div className={styles.bookInfo}>
        <div className={styles.rating}>
          {order > 0 && (
            <div className={styles.bookOrder}>{order}</div>
          )}
          <BookRating
            value={bookRating.rating}
            isTiny />
        </div>
        <Link
          to={book.getLink()}
          className={styles.bookName}>
          <MultilineEllipsisText maxLinesCount={2}>{book.name}</MultilineEllipsisText>
        </Link>
        {mainAuthor && (
          <div className={styles.bookAuthorWrapper}>
            <Link
              to={mainAuthor.getLink()}
              className={styles.bookAuthor}>
              <MultilineEllipsisText maxLinesCount={2}>{mainAuthor.cover_name}</MultilineEllipsisText>
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

VerticalBookCard.propTypes = {
  book: PropTypes.shape({
    default_cover: PropTypes.string.isRequired,
    absolute_url: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    read_count: PropTypes.number.isRequired,
    main_author: PropTypes.shape({
      cover_name: PropTypes.string.isRequired,
      absolute_url: PropTypes.string.isRequired,
    }),
    rating: PropTypes.shape({
      rating: PropTypes.number.isRequired,
      votes: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
  order: PropTypes.number,
  isActiveItem: PropTypes.bool,
};

VerticalBookCard.defaultProps = {
  order: null,
  isActiveItem: false,
};

export default VerticalBookCard;
